/**
 * Terminvorschläge als Text für eine neue Mail (#200).
 *
 * Die Zeiten kommen fertig formuliert vom Server („Montag, 05.10.2026
 * zwischen 9 und 10 Uhr") — dieselbe Formulierung wie bei SMS und Planer.
 * Hier wird nur der Absatz gebaut und an den bestehenden Mailtext gehängt.
 * Nichts wird reserviert, gebucht oder gesendet.
 */
export function terminvorschlaegeBlock(labels: string[]): string {
  const zeilen = labels.map((l) => (l || "").trim()).filter(Boolean)
  if (!zeilen.length) return ""
  return [
    "Gern schlagen wir Ihnen folgende Termine vor:",
    ...zeilen.map((l) => `- ${l}`),
    "Bitte geben Sie uns kurz Bescheid, welcher Termin Ihnen passt.",
  ].join("\n")
}

/** Block an den vorhandenen Text hängen, durch eine Leerzeile getrennt. */
export function mitTerminvorschlaegen(bisher: string, labels: string[]): string {
  const block = terminvorschlaegeBlock(labels)
  if (!block) return bisher
  const b = bisher.replace(/\s+$/, "")
  return b ? `${b}\n\n${block}\n` : `${block}\n`
}
